import {Link} from "@mui/material";
import ReactGA from "react-ga4";

export const LogExternal = (url) => ReactGA.event({
    category: 'User',
    action: 'External Link',
    label: url
})

export const ExternalLink = (props) => <Link target={"_blank"} href={props.href} onClick={() => LogExternal(props.href)}>
    {props.children}
</Link>